var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"login"}},[_c('div',{staticClass:"login-wrap"},[_c('FormAuth',{attrs:{"user":_vm.user,"err":_vm.err},on:{"login":_vm.login,"clear-err":function($event){_vm.err = []}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }